<div class="PGDetailField">
    <label [innerHTML]="fieldData.label | locTranslate"></label>
    <div class="d-flex align-items-center">
        @if (fieldData.type != 'split' && fieldData.type != 'info') {
            <span locFormat="byConfig" [formatValue]="cleanValue" [formatParam]="fieldData" [formatExtraParam]="getExtraParam()" placeholder="-"></span>
        }

        @if (fieldData.type == 'info') {
            <span>
                <i class="fa-regular fa-info-circle me-2"></i>
                <span [innerHTML]="fieldData.tooltip | locTranslate"></span>
            </span>
        }
    </div>
</div>